/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
document.addEventListener('DOMContentLoaded', () => {
	const galleryElement = document.querySelector('[data-fancybox-custom="gallery"]');
	const closeText = galleryElement?.dataset.fancyboxCloseText;

	Fancybox.bind('[data-fancybox-custom="gallery"]', {
		groupAll: true,
		closeButton: true,
		on: {
			done: (fancybox, slide) => {
				const closeButton = slide.el.querySelector('.is-close-btn');
				if (closeButton) {
					closeButton.classList.add(...['btn', 'outline']);
					closeButton.innerHTML = closeText + closeButton.innerHTML;
				}
			},
		},
	});
});
